import React, {
  useEffect, useState,
} from 'react';
import classnames from 'classnames';

import './BasicDropdown.scss';

const BasicDropdown = ( {
  className,
  label,
  options,
  handleOptionOnClick,
} ) => {
  const [ dropdownIsOpen, setDropdownIsOpen ] = useState( false );
  const [ activeSelectionObject, setActiveSelectionObject ] = useState( {} );

  // Set initial selected selection option and active selection option.
  useEffect( () => {
    const initialOption = options.find(
      ( option ) => option.isDefault === true,
    );
    setActiveSelectionObject( initialOption );
  }, [ options ] );

  const handleOptionClick = ( option ) => {
    handleOptionOnClick( option );
    setActiveSelectionObject( option );
    setDropdownIsOpen( false );
  };

  return (
    <div className={`basicDropdown ${className}`}>

      { label && (
        <div className="basicDropdown__label">{ label }</div>
      )}

      <div className="basicDropdown__dropdown">

        <button
          type="button"
          className={classnames( 'basicDropdown__trigger', {
            'basicDropdown__trigger--inactive': dropdownIsOpen,
          } )}
          onClick={() => {
            setDropdownIsOpen( true );
          }}
        >
          { activeSelectionObject.text }
        </button>

        <div
          className={classnames( 'basicDropdown__options', {
            'basicDropdown__options--inactive': !dropdownIsOpen,
          } )}
        >

          { options.map( ( option ) => (
            <button
              key={option.id}
              type="button"
              className={classnames(
                'basicDropdown__option',
                { 'basicDropdown__option--active': option.text === activeSelectionObject.text },
              )}
              onClick={() => {
                handleOptionClick( option );
              }}
            >
              { option.text }
            </button>
          ) )}
        </div>
      </div>
    </div>
  );
};

export default BasicDropdown;
